exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1h__PPS-xb-saLCRQoRryI{width:100px;height:100px;position:relative;top:40%;margin:0 auto}", ""]);

// exports
exports.locals = {
	"spaner_outer": "_1h__PPS-xb-saLCRQoRryI"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./apps/pages/component/Loading/index.css
// module id = 1598
// module chunks = 1